import { useRef, useState, useEffect, useCallback } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/** Horizontal, touch-swipeable slider with snap points and desktop arrows. */
export default function SwipeRow({ children, itemClass, testid }) {
  const ref = useRef(null);
  const [edge, setEdge] = useState({ start: true, end: false });
  const update = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setEdge({ start: el.scrollLeft <= 4, end: el.scrollLeft + el.clientWidth >= el.scrollWidth - 4 });
  }, []);
  useEffect(() => {
    update();
    const el = ref.current;
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [update, children]);
  const go = (d) => ref.current?.scrollBy({ left: d * ref.current.clientWidth * 0.8, behavior: "smooth" });
  const items = Array.isArray(children) ? children : [children];
  return (
    <div className="relative group/row" data-testid={testid}>
      <div ref={ref} onScroll={update} className="flex gap-4 overflow-x-auto snap-x snap-mandatory no-scrollbar scroll-smooth pb-3 pt-1 motion-reduce:scroll-auto">
        {items.map((c, i) => <div key={i} className={`snap-start shrink-0 ${itemClass}`}>{c}</div>)}
      </div>
      {!edge.start && <button onClick={() => go(-1)} aria-label="Scroll left" data-testid={testid && `${testid}-prev`}
        className="hidden sm:flex absolute -left-4 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white border border-[#E5EAE6] shadow-sm items-center justify-center text-[#236B45] hover:border-[#236B45]/50 transition-colors z-10"><ChevronLeft size={18} /></button>}
      {!edge.end && <button onClick={() => go(1)} aria-label="Scroll right" data-testid={testid && `${testid}-next`}
        className="hidden sm:flex absolute -right-4 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-white border border-[#E5EAE6] shadow-sm items-center justify-center text-[#236B45] hover:border-[#236B45]/50 transition-colors z-10"><ChevronRight size={18} /></button>}
    </div>
  );
}
